import Vue from 'vue';
import store from '../../store'; // Importa el store
import { mapActions } from 'vuex';

const DIVAS_THEME = 'divas';
const CHADS_THEME = 'chads';
const THEMES = [DIVAS_THEME, CHADS_THEME];
const DEFAULT_THEME = DIVAS_THEME;

function setCSSTheme(theme) {
  if (!theme) {
    theme = DEFAULT_THEME;
  }

  const cssClasses = document.body.classList;

  for (const theme of THEMES) {
    if (cssClasses.contains(theme)) {
      cssClasses.remove(theme);
    }
  }

  cssClasses.add(theme);
}

export default new Vue({
  store,
  data: {
    themes: [DIVAS_THEME, CHADS_THEME],
    defaultTheme: DIVAS_THEME,
    selectedTheme: store.state.general.site_type,
    DIVAS_THEME,
    CHADS_THEME,
  },
  methods: {
    ...mapActions(['updateSiteType']),

    /**
     * Check if body has a theme class
     * If it hasnt, set the default theme to divas
     */
    getTheme() {
      if (!this.selectedTheme) {
        return this.defaultTheme;
      }

      return this.selectedTheme;
    },

    setTheme(theme) {
      if (!THEMES.includes(theme)) return;

      setCSSTheme(theme);
      this.updateSiteType(theme);
      this.selectedTheme = theme;
    },

    isChadsTheme() {
      return this.getTheme() === CHADS_THEME;
    },

    isDivasTheme() {
      return this.getTheme() === DIVAS_THEME;
    },

    changeBySex(sex) {
      switch (sex) {
        case 'M': {
          this.setTheme(CHADS_THEME);
          break;
        }
        case 'F': {
          this.setTheme(DIVAS_THEME);
          break;
        }
        case 'X': break;
      }
    },

    parseWebstarDefaultsImageUrl(imageUrl) {
      const DIVAS_DEFAULT = "img/webstar_defaults/";
      const CHADS_DEFAULT = "img/themes/chads/webstar_defaults/";
      let tmp = imageUrl;

      if (tmp && tmp.indexOf(DIVAS_DEFAULT) !== -1 && this.isChadsTheme()) {
        tmp = tmp.replace(DIVAS_DEFAULT, CHADS_DEFAULT);
      } else if (tmp && tmp.indexOf(CHADS_DEFAULT) !== -1 && this.isDivasTheme()) {
        tmp = tmp.replace(CHADS_DEFAULT, DIVAS_DEFAULT);
      }

      return tmp;
    },

  },
  setup() {
    const siteType = store.state.general.site_type;
    setCSSTheme(siteType);
  }
});
